import Skeleton from "react-loading-skeleton";
import styled from "styled-components/macro";

function BareMessageSkeleton({className}) {
    return (
        <div className={className}>
            <header>
                <Skeleton height={11} width={250}/>
            </header>
            <main>
                <Skeleton height={11} width="100%" count={2}/>
                <Skeleton height={11} width="35%"/>
            </main>
        </div>
    );
}

const MessageSkeleton = styled(BareMessageSkeleton)`
  padding: 16px;
  header > * {
    display: block;
    margin-bottom: 8px;
  }

`;

export default MessageSkeleton;
